<a [name]="HeaderConfig.headlineWithInfo.anchorName"></a>
<div class="baustein-header" [ngClass]="{'vv-switch': true, 'baustein-border-bottom': !this.showInfo}">
  <h3>
    <app-tooltip-enabled-markup [html]="HeaderConfig.headlineWithInfo.headline"></app-tooltip-enabled-markup>
    <app-info-toggle *ngIf="HeaderConfig.headlineWithInfo.infoText" (changed)="this.onInfoBoxChanged($event)"></app-info-toggle>
  </h3>
  <div *ngIf="HeaderConfig.tariffOption != null && !HeaderConfig.tariffOption.yesnoswitch.invisible" class="baustein-switch">


    <div [ngClass]="{'onoffswitch-vv': true}" *ngIf="HeaderConfig.tariffOption.calculationId !== '' && HeaderConfig.tariffOption.calculationId != null">
      <div class="onoffswitch-vv-switch" *ngIf="!this.apiSvc.isBusy">
        <input type="checkbox" [checked]="this.isTariffOptionActive()" [value]="this.isTariffOptionActive()" [disabled]="this.isTariffOptionDisabled()"
          id={{HeaderConfig.tariffOption.calculationId}}
          name={{HeaderConfig.tariffOption.calculationId}}
          class="onoffswitch-checkbox"
          (change)="this.onSwitchChanged($event)"
        >
        <label class="onoffswitch-label" for={{HeaderConfig.tariffOption.calculationId}}>
          <div class="onoffswitch-inner"></div>
          <div id="{{HeaderConfig.tariffOption.calculationId}}_switch" class="onoffswitch-switch"></div>
        </label>
      </div>


      <div class="loading-container" *ngIf="this.apiSvc.isBusy">
        <div class="loading">
          <ngx-loading [show]="this.apiSvc.isBusy"
            [config]="{animationType: ngxLoadingAnimationTypes.rectangleBounce, primaryColour: '#0D57A6', fullScreenBackdrop: false, backdropBackgroundColour: 'rgba(0, 0, 0, 0.0)'}">
          </ngx-loading>
        </div>
      </div>


    </div>


  </div>

</div>

<div class="baustein-header-info"
  [ngClass]="{ 'baustein-header-info': true, 'baustein-border-bottom': this.showInfo }"
  *ngIf="this.showInfo && HeaderConfig.headlineWithInfo.infoText"
>
  <app-tooltip-enabled-markup [html]="HeaderConfig.headlineWithInfo.infoText.content"></app-tooltip-enabled-markup>
</div>

